import t from "./_baseGet.js";
var a = t;
function o(e) {
  return function(r) {
    return a(r, e);
  };
}
var p = o;
export {
  p as default
};
//# sourceMappingURL=_basePropertyDeep.js.map
